import React from "react";
import { Box } from "@mui/material";
import {
  MyHrSystemSettingsCacheCard,
  MyHrSystemSettingsHelpdeskCard,
  MyHrSystemSettingsLoginCard,
} from "my-hr/components";
import { OcPageSideMenu, OcPageTransition } from "oc/components";
import { useOcIsMobile, useOcPageSideMenu } from "oc/hooks";

const menuDef = [
  {
    id: "loginSettings",
    label: "MY_HR_SIGN_IN",
    roles: ["MyHR.admin"],
  },
  {
    id: "clearCache",
    label: "MY_HR_CLEAR_CACHE",
    roles: ["MyHR.admin"],
  },
  {
    id: "helpdeskContacts",
    label: "MY_HR_HELPDESK_CONTACTS",
    roles: ["MyHR.admin"],
  },
];
export const MyHRAdminSystemSettingsPage = () => {
  const stateId = "myHrSystemSettingsPageMenuActiveItem";
  const { state: selectedItem } = useOcPageSideMenu({
    id: stateId,
    initialValue: menuDef[0].id,
  });

  const isMobile = useOcIsMobile();

  return (
    <OcPageTransition>
      <Box>
        <Box
          id="my-hr-admin-system-settings-title"
          height="80px"
          style={{ backgroundColor: "#cc0033" }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingLeft="14px"
        >
          <Box style={{ color: "white", fontSize: "24px" }}>MyHR</Box>
        </Box>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          <OcPageSideMenu stateId={stateId} menuDef={menuDef} />
          <Box
            id="my-hr-admin-system-settings"
            flexGrow={1}
            padding={isMobile ? "16px 0px" : "16px"}
          >
            {selectedItem === "loginSettings" && (
              <MyHrSystemSettingsLoginCard />
            )}
            {selectedItem === "clearCache" && <MyHrSystemSettingsCacheCard />}
            {selectedItem === "helpdeskContacts" && (
              <MyHrSystemSettingsHelpdeskCard isMobile={isMobile} />
            )}
          </Box>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyHRAdminSystemSettingsPage;
